export default __webpack_public_path__ + "static/media/logo_caregility_lg.8539efb2.svg";